import moment from "moment";
import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
(module => {
    module.component("correctionAboutFactRollingForecast", {
        template: require("./correctionAboutFactRollingForecastComponent.html"),
        bindings: {
            displayTableForecast: "=",
            forecast: "=",
            parameters: "<",
            corrections: "=",
            correctionService: "<",
            isEditable: "<"
        },
        controller: [
            "$scope",
            "$injector",
            "PPGChartAndTableService",
            "correctionAboutFactsService",
            "forecastConfigurationService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            angularServicesNames.$uibModal,
            "dtpChartService",
            "clipboardService",
            "selectElementAndConvertService",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $injector: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                correctionAboutFactsService: $TSFixMe,
                forecastConfigurationService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                $uibModal: ng.ui.bootstrap.IModalService,
                dtpChartService: $TSFixMe,
                clipboardService: $TSFixMe,
                selectElementAndConvertService: $TSFixMe
            ) {
                const $ctrl = this;

                $ctrl.coordinatesSelectedCells = {};
                $ctrl.showSpecialElement = false;

                function getCorrectionService() {
                    return $injector.get($ctrl.correctionService);
                }

                $ctrl.searchCorrectionPrompt = (searchString: $TSFixMe, source: $TSFixMe) =>
                    forecastConfigurationService.searchCorrectionPrompt(searchString, source);

                $ctrl.dynamicPopover = {
                    templateUrl: "myPopoverTemplate.html"
                };

                $ctrl.openPopup = (obj: $TSFixMe, idx: $TSFixMe, item: $TSFixMe, event: $TSFixMe) => {
                    enablePasting(event);

                    $ctrl.yearData = item;
                    let prepareMonth = idx < 10 ? "0" + idx : idx,
                        prepareDate = moment.utc(item.year + "-" + prepareMonth, "YYYY-MM").toDate();

                    $ctrl.correctionAboutFacts = {
                        startDate: prepareDate,
                        endDate: prepareDate,
                        baseValue: obj.forecast,
                        correct: obj.correctData ? obj.correctData.correct : obj.forecast,
                        desc: obj.correctData ? obj.correctData.desc : null,
                        impactType: obj.correctData ? obj.correctData.impactType : "percentage",
                        explicitImpact:
                            obj.correctData && obj.correctData.impactType === "explicit"
                                ? obj.correctData.impact
                                : null,
                        percentageImpact:
                            obj.correctData && obj.correctData.impactType === "percentage"
                                ? correctionAboutFactsService.correctionExFactoryPercent(
                                      obj.correctData.correct,
                                      obj.forecast
                                  )
                                : correctionAboutFactsService.correctionExFactoryPercent(obj.forecast, obj.forecast)
                    };
                };

                $ctrl.removeCorrect = (start: $TSFixMe, end: $TSFixMe) => {
                    getCorrectionService().removeCorrect(start, end, $ctrl.forecast, $ctrl.parameters);
                };

                $ctrl.selectTargetInput = ($event: $TSFixMe) => angular.element($event.target).select();

                function startWatchCoordinatesSelectedCells() {
                    $scope.$watch(
                        "$ctrl.coordinatesSelectedCells",
                        function (nValue: $TSFixMe, oValue: $TSFixMe) {
                            if (!_.isEmpty(nValue)) {
                                const data = selectElementAndConvertService.pickElementFromArray(
                                    $ctrl.coordinatesSelectedCells,
                                    $ctrl.displayTableForecast,
                                    "data"
                                );
                                $ctrl.dataToResume = selectElementAndConvertService.setArithmeticAverage(
                                    data,
                                    ["forecast", "correctData"],
                                    "correct"
                                );
                                $ctrl.showSpecialElement = true;
                            } else {
                                $ctrl.showSpecialElement = false;
                            }
                        },
                        true
                    );
                }

                $ctrl.$onInit = () => {
                    startWatchCoordinatesSelectedCells();
                };

                $ctrl.save = (model: $TSFixMe) => {
                    getCorrectionService().updateCorrect(
                        {
                            startDate: model.startDate,
                            endDate: model.endDate,
                            risk: 100,
                            direction: 1,
                            desc: model.desc,
                            impactType: model.impactType,
                            impact: model.impactType === "explicit" ? model.explicitImpact : model.percentageImpact,
                            absoluteValue: model.absoluteValue
                        },
                        $ctrl.forecast,
                        $ctrl.parameters
                    );
                };

                $ctrl.updateValue = (val: $TSFixMe) => {
                    $ctrl.correctionAboutFacts.correct = correctionAboutFactsService.correctionExFactoryValue(
                        val.percentageImpact,
                        val.baseValue
                    );
                };

                $ctrl.updatePercent = (val: $TSFixMe) => {
                    if (val.baseValue == 0) {
                        $ctrl.correctionAboutFacts.absoluteValue = val.correct;
                    } else {
                        $ctrl.correctionAboutFacts.percentageImpact =
                            correctionAboutFactsService.correctionExFactoryPercent(val.correct, val.baseValue);
                        $ctrl.correctionAboutFacts.absoluteValue = null;
                    }
                };

                $ctrl.exportTable = function () {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable(
                                "table.xlsx",
                                PPGChartAndTableService.getCorrectionAboutFactForTableExport($ctrl.displayTableForecast)
                            ),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $ctrl.onImpactTypeChange = function () {
                    if ($ctrl.correctionAboutFacts.impactType === "percentage")
                        $ctrl.updatePercent($ctrl.correctionAboutFacts);
                };
                $ctrl.onPaste = function (event: $TSFixMe) {
                    if (!$ctrl.isEditable) {
                        return;
                    }
                    const maxAllowedNumberOfCorrects = dtpChartService.getPeriodLenghtInMonths(
                        $ctrl.correctionAboutFacts.startDate,
                        $ctrl.parameters.forecastEndDate
                    );

                    let values = clipboardService.getData(event.originalEvent.clipboardData);
                    values.splice(maxAllowedNumberOfCorrects);

                    if (values && values.length) {
                        hidePopover();
                        var modalInstance = $uibModal.open({
                            component: "correctionAboutFactsBatchEdit",
                            resolve: {
                                inputData: () => values,
                                isRf: () => true
                            }
                        });

                        modalInstance.result.then(function (correctionInfo: $TSFixMe) {
                            var date = $ctrl.correctionAboutFacts.startDate;
                            values.forEach((p: $TSFixMe) => {
                                getCorrectionService().updateCorrect(
                                    {
                                        risk: 100,
                                        direction: 1,
                                        impactType: "explicit",
                                        impact: p,
                                        startDate: date,
                                        endDate: date,
                                        desc: correctionInfo.desc
                                    },
                                    $ctrl.forecast,
                                    $ctrl.parameters
                                );

                                date = moment.utc(date).add(1, "M").toDate();
                            });
                        });
                    }
                };

                function enablePasting(event: $TSFixMe) {
                    angular.element(event.target).find("input.pastable-input").focus();
                }

                function hidePopover() {
                    setTimeout(() => {
                        angular.element(document.querySelector("body")!).click();
                    }, 0);
                }
            }
        ]
    });
})(angular.module("topline.components"));
